export const LOGIN = {
    name: 'Login Page',
    path: '/login',
};

export const PROFILE = {
    name: 'Profile',
    path: '/profile',
};
